import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import AiDrivenCustomerImage from './AiDrivenCustomerImage'

const copy = {
  heading: `Use AI to turn every customer interaction into a unique customer experience`,
  description: `Ensure your customer engagement gets smarter and more tailored all the time with user-friendly predictive and generative AI that improves targeting and personalization for lower costs and higher conversion rates.`,
}

const link = {
  text: `Explore Segment AI`,
  url: `/solutions/ai/`,
}

const features = [
  {
    heading: `Gain a deeper understanding of your customer with trusted data built on relationships`,
    description: `Understand the nuances and complexities of every customer’s relationship to your brand, their household, account teams, and the world around them with enriched and extended golden profiles.`,
  },
  {
    heading: `Put accessible and actionable AI at marketers’ fingertips`,
    description: `Quickly and easily launch precisely targeted and timely campaigns—without the help of data teams—by putting the power of predictive AI directly in the hands of marketers.`,
  },
  {
    heading: `Create, activate, and iterate faster for better results`,
    description: `Build the most engaging campaigns in minutes with customer-aware generative AI that automates who to target, how to build the journey, and what messages will resonate best with real-time insights for better results.`,
  },
]

const OrchestrateJourneys = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionWrapper variant="2Col" reverse={true}>
      <StyledSectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>

        <ColumnTrackWrapper>
          <ColumnTrack gap="small">
            {features.map((feature, index) => (
              <FeatureBoxBase key={index} alignment="left">
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
        <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
      </StyledSectionCopy>
      <Section.Contents>
        <AiDrivenCustomerImage />
      </Section.Contents>
    </SectionWrapper>
  )
}

const SectionWrapper = styled(SectionBase)`
  overflow-x: visible;
`

const StyledSectionCopy = styled(Section.Copy)`
  direction: ltr;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    max-width: 440px;
  }
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

export default OrchestrateJourneys
